// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.notification-popup {
  background: white;
  border-radius: 15px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 10px 50px rgba(0, 0, 0, 0.5);
  animation: slideIn 0.4s ease;
  overflow: hidden;
  border: 3px solid #667eea;
}

.notification-popup.overdue {
  border-color: #e74c3c;
}

@keyframes slideIn {
  from {
    transform: scale(0.8) translateY(-50px);
    opacity: 0;
  }
  to {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}

.notification-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  position: relative;
}

.notification-popup.overdue .notification-header {
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
}

.notification-icon {
  font-size: 40px;
  animation: ring 1s ease infinite;
}

@keyframes ring {
  0%, 100% {
    transform: rotate(0deg);
  }
  10%, 30% {
    transform: rotate(-15deg);
  }
  20%, 40% {
    transform: rotate(15deg);
  }
}

.notification-title {
  flex: 1 1;
}

.notification-title h3 {
  margin: 0 0 5px 0;
  font-size: 20px;
}

.time-badge {
  display: inline-block;
  background: rgba(255, 255, 255, 0.3);
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
}

.close-notif-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  color: white;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s;
}

.close-notif-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.notification-body {
  padding: 25px;
  max-height: 400px;
  overflow-y: auto;
}

.lead-info,
.followup-details {
  margin-bottom: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 10px;
}

.followup-details h4 {
  margin: 0 0 15px 0;
  color: #2c3e50;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #e0e0e0;
}

.info-row:last-child {
  border-bottom: none;
}

.info-row .label {
  font-size: 13px;
  color: #7f8c8d;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-row .value {
  font-size: 14px;
  color: #2c3e50;
  font-weight: 500;
  text-align: right;
  max-width: 60%;
}

.customer-name {
  color: #667eea;
  font-weight: 700;
  font-size: 16px;
}

.purpose {
  color: #e74c3c;
  font-weight: 600;
}

.info-row .value a {
  color: #667eea;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s;
}

.info-row .value a:hover {
  color: #764ba2;
  text-decoration: underline;
}

.notes-section {
  padding-top: 10px;
  border-top: 2px solid #e0e0e0;
  margin-top: 10px;
}

.notes-section .label {
  display: block;
  font-size: 13px;
  color: #7f8c8d;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.notes-text {
  margin: 0;
  padding: 10px;
  background: white;
  border-radius: 5px;
  color: #2c3e50;
  line-height: 1.6;
  font-size: 14px;
}

.notification-footer {
  padding: 20px;
  background: #f8f9fa;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  border-top: 1px solid #e0e0e0;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-success {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
  color: white;
}

.btn-success:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(56, 239, 125, 0.4);
}

.btn-secondary {
  background: #95a5a6;
  color: white;
}

.btn-secondary:hover {
  background: #7f8c8d;
}

.more-notifications {
  background: #fff3cd;
  color: #856404;
  padding: 10px 20px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  border-top: 1px solid #ffeaa7;
}

/* Responsive */
@media (max-width: 768px) {
  .notification-popup {
    width: 95%;
  }
  
  .notification-header {
    padding: 15px;
  }
  
  .notification-icon {
    font-size: 30px;
  }
  
  .notification-title h3 {
    font-size: 16px;
  }
  
  .notification-body {
    padding: 15px;
  }
  
  .notification-footer {
    flex-direction: column;
    gap: 8px;
  }
  
  .notification-footer .btn {
    width: 100%;
  }
  
  .info-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
  
  .info-row .value {
    max-width: 100%;
    text-align: left;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FollowUpNotification.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,0CAA0C;EAC1C,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,uCAAuC;IACvC,UAAU;EACZ;EACA;IACE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".notification-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.notification-popup {\n  background: white;\n  border-radius: 15px;\n  max-width: 500px;\n  width: 90%;\n  box-shadow: 0 10px 50px rgba(0, 0, 0, 0.5);\n  animation: slideIn 0.4s ease;\n  overflow: hidden;\n  border: 3px solid #667eea;\n}\n\n.notification-popup.overdue {\n  border-color: #e74c3c;\n}\n\n@keyframes slideIn {\n  from {\n    transform: scale(0.8) translateY(-50px);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1) translateY(0);\n    opacity: 1;\n  }\n}\n\n.notification-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  position: relative;\n}\n\n.notification-popup.overdue .notification-header {\n  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);\n}\n\n.notification-icon {\n  font-size: 40px;\n  animation: ring 1s ease infinite;\n}\n\n@keyframes ring {\n  0%, 100% {\n    transform: rotate(0deg);\n  }\n  10%, 30% {\n    transform: rotate(-15deg);\n  }\n  20%, 40% {\n    transform: rotate(15deg);\n  }\n}\n\n.notification-title {\n  flex: 1;\n}\n\n.notification-title h3 {\n  margin: 0 0 5px 0;\n  font-size: 20px;\n}\n\n.time-badge {\n  display: inline-block;\n  background: rgba(255, 255, 255, 0.3);\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.close-notif-btn {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  color: white;\n  font-size: 24px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.3s;\n}\n\n.close-notif-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.notification-body {\n  padding: 25px;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.lead-info,\n.followup-details {\n  margin-bottom: 20px;\n  padding: 15px;\n  background: #f8f9fa;\n  border-radius: 10px;\n}\n\n.followup-details h4 {\n  margin: 0 0 15px 0;\n  color: #2c3e50;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.info-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 0;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.info-row:last-child {\n  border-bottom: none;\n}\n\n.info-row .label {\n  font-size: 13px;\n  color: #7f8c8d;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.info-row .value {\n  font-size: 14px;\n  color: #2c3e50;\n  font-weight: 500;\n  text-align: right;\n  max-width: 60%;\n}\n\n.customer-name {\n  color: #667eea;\n  font-weight: 700;\n  font-size: 16px;\n}\n\n.purpose {\n  color: #e74c3c;\n  font-weight: 600;\n}\n\n.info-row .value a {\n  color: #667eea;\n  text-decoration: none;\n  font-weight: 600;\n  transition: color 0.3s;\n}\n\n.info-row .value a:hover {\n  color: #764ba2;\n  text-decoration: underline;\n}\n\n.notes-section {\n  padding-top: 10px;\n  border-top: 2px solid #e0e0e0;\n  margin-top: 10px;\n}\n\n.notes-section .label {\n  display: block;\n  font-size: 13px;\n  color: #7f8c8d;\n  font-weight: 600;\n  text-transform: uppercase;\n  margin-bottom: 8px;\n}\n\n.notes-text {\n  margin: 0;\n  padding: 10px;\n  background: white;\n  border-radius: 5px;\n  color: #2c3e50;\n  line-height: 1.6;\n  font-size: 14px;\n}\n\n.notification-footer {\n  padding: 20px;\n  background: #f8f9fa;\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  border-top: 1px solid #e0e0e0;\n}\n\n.btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.3s;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.btn-success {\n  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);\n  color: white;\n}\n\n.btn-success:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(56, 239, 125, 0.4);\n}\n\n.btn-secondary {\n  background: #95a5a6;\n  color: white;\n}\n\n.btn-secondary:hover {\n  background: #7f8c8d;\n}\n\n.more-notifications {\n  background: #fff3cd;\n  color: #856404;\n  padding: 10px 20px;\n  text-align: center;\n  font-size: 13px;\n  font-weight: 600;\n  border-top: 1px solid #ffeaa7;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .notification-popup {\n    width: 95%;\n  }\n  \n  .notification-header {\n    padding: 15px;\n  }\n  \n  .notification-icon {\n    font-size: 30px;\n  }\n  \n  .notification-title h3 {\n    font-size: 16px;\n  }\n  \n  .notification-body {\n    padding: 15px;\n  }\n  \n  .notification-footer {\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .notification-footer .btn {\n    width: 100%;\n  }\n  \n  .info-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 5px;\n  }\n  \n  .info-row .value {\n    max-width: 100%;\n    text-align: left;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
